export function apiBase():string {
  return process.env.VUE_APP_POINTING_REST_API_URL
}
